import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import Loading from './components/Loading';
import { ThemeProvider, createTheme } from '@mui/material';
import { queryParam } from './utils';
import { DEF_COLOR } from './constants';

const mainColor = `#${queryParam('mainColor', DEF_COLOR)}`;

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: mainColor,
        },
    },
});

createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
        <ErrorBoundary fallback={<Loading />}>
            <SWRConfig
                value={{
                    keepPreviousData: false,
                    refreshWhenHidden: true,
                    refreshWhenOffline: true,
                    suspense: true,
                }}>
                <ThemeProvider theme={theme}>
                    <Suspense fallback={<Loading />}>
                        <App />
                    </Suspense>
                </ThemeProvider>
            </SWRConfig>
        </ErrorBoundary>
    </StrictMode>,
);
